import { INLINE_MARKDOWN_COMPONENTS } from '@/lib/crm/components/inline-markdown-components';
import { MarkdownContent } from '@/lib/crm/components/MarkdownContent';

interface ClarifyingRichTextProps {
  content: string;
  orgId?: number;
  className?: string;
}

/**
 * Renders a backend clarifying string (which may contain `<Entity …>` markup) as
 * INLINE entity-aware markdown — no block `<p>` — so it is valid inside a `<legend>`,
 * a label `<p>`, or a description `<p>` (all phrasing contexts where a nested block
 * element would be invalid HTML).
 *
 * Assumes clarifying text is a single inline line (plain text + `<Entity …>` tags +
 * optional inline emphasis/links). Block constructs (headings, paragraphs, lists,
 * blockquotes, code blocks) are overridden to render inline via
 * `INLINE_MARKDOWN_COMPONENTS`; table elements are not expected and are not overridden.
 */
export function ClarifyingRichText({
  content,
  orgId,
  className,
}: ClarifyingRichTextProps) {
  return (
    <MarkdownContent
      content={content}
      orgId={orgId}
      size='compact'
      as='span'
      components={INLINE_MARKDOWN_COMPONENTS}
      className={className}
      entityInteractive={false}
    />
  );
}
